<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-also-by element-with-heading full-character-formatting" id="also-by">
<div class="heading heading-with-title heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title case-upper">ALSO IN THE INSPECTOR APPLEBY MYSTERIES</h1>
</div>
</div>
</div>
</div>
<div class="text" id="also-by-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center also-by-content">Death at the President’s Lodging</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Hamlet, Revenge!</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Lament for a Maker</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Stop Press</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">The Secret Vanguard</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">There Came Both Mist and Snow</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">The Daffodil Affair</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">The Weight of the Evidence</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Appleby’s End</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">A Night of Errors</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Operation Pax</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">A Private View</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Appleby Talks</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Appleby Talks Again</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Death on a Quiet Day</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">The Long Farewell</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Hare Sitting Up</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Silence Observed</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">The Crabtree Affair</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Appleby Intervenes: Three Tales from Scotland Yard</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">The Bloody Wood</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Appleby at Allington</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">A Family Affair</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Death at The Chase</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">An Awkward Lie</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">The Open House</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Appleby’s Answers</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Appleby’s Other Story</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">The Appleby File</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">The Gay Phoenix</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">The Ampersand Papers</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Sheiks and Adders</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Appleby and Honeybath</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Carson’s Conspiracy</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Appleby and The Ospreys</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Appleby Talks About Crime</p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// also-by-michael-innes.vue?ec318f1c